do ->
  'use strict'

  # ANGULAR CONTROLLER FUNCTION
  VisualizarProcessoController = (currentUserId, $window) ->
    vm = @

    ### CONSTANTS ###

    ### VARIABLES VIEW MODEL ###

    ### VARIAVEIS PRIVATE ###

    ### WATCHES ###

    # INIT SETUP
    init = () =>
      return

    ### METHODS PRIVATE ###


    ### METHODS VIEW MODEL ###

    vm.saveLocalStorage = (new_item) ->
      key = "processos_visualizados_#{currentUserId}"
      dadosLocalStorage = $window.localStorage.getItem(key)
      dados = JSON.parse(dadosLocalStorage) if dadosLocalStorage != 'undefined'

      if dados
        $window.localStorage.setItem(key, JSON.stringify({dados..., new_item...}))
      else
        $window.localStorage.setItem(key, JSON.stringify(new_item))
      return

    # CALL INIT SETUP
    init()

    return


  # ANGULAR CONTROLLER
  angular.module('mainApp').controller 'VisualizarProcessoController', VisualizarProcessoController

  # ANGULAR INJECT DEPENDENCIES
  VisualizarProcessoController.$inject = ['currentUserId', '$window']

  # END BLOCK SCRIPT
  return
